import { withAsyncLoading } from '../../../Components/Templates/AsyncPageLoading/withAsyncPageLoading';

const LoadableWorkerDetails = withAsyncLoading(async () =>
    import('./WorkerDetailsPage').then((res) => res.WorkerDetailsPage)
);

export { LoadableWorkerDetails };
